// Design by Aditi Mishra - SnapPaisa Website
export const APP_NAME = 'SnapPaisa';
export const CONTACT_NUMBER = '8750238443';
export const SUPPORT_AVAILABILITY = '10 AM - 6:30 PM, Monday to Saturday';
export const NBFC_ADDRESS = 'H-144, Sector-63, Noida, Uttar Pradesh 201301';
export const CONTACT_EMAIL = 'care@snappaisa.com';
export const NBFC_NAME = 'SnapPaisa Financial Services - RBI Approved NBFC';

// PayU Configuration
export const PAYU_MERCHANT_KEY = '6WY2dF';
export const PAYU_SALT_KEY = '256 bit'; // Your salt key
export const PAYU_TEST_MODE = true; // Set to false for production`